export default __webpack_public_path__ + "a2b9bed418cb6aa8c09899f77b36765c.svg";